import config from '../../config';
import { goldSilverFonts } from './Themes/GoldSilverTheme';
import { hardAssetsAllianceFonts } from './Themes/GbiDirectTheme';
import { contosoFonts } from './Themes/ContosoTheme';

const getThemeFonts = () => {
  const { brokerTheme } = config;

  switch (brokerTheme) {
    case 'HardAssetsAlliance':
      return hardAssetsAllianceFonts;

    case 'GoldSilver':
      return goldSilverFonts;
    case 'Contoso':
      return contosoFonts;

    default:
      return hardAssetsAllianceFonts;
  }
};

const themeFonts = getThemeFonts();

export default themeFonts;
